
exports.handler = (val) => {
  const in_min = 65;
  const in_max = 93;

  if(val > in_max) return 1;
  if(val < in_min) return 0;

  return (val - in_min)/(in_max - in_min)
};